import { createSlice  } from '@reduxjs/toolkit';
import {
  createLineChartOptions, createMixedChartOptions, 
} from '../../utils/chart';
import _cloneDeep from 'lodash/cloneDeep';
import apiservice from '../../services/apiservice';

const initialState = {
  dashboardFiters: apiservice.getDashboardFilters(),
  topFarmersFiters: apiservice.getTopFarmersFilters(),
  registeredUsersChart: {
    requesting: false,
    error: null,
    success: false,
    filters: {},
    chartData: {
      options: {},
      series: []
    },
  },
  registeredAnimalsChart: {
    requesting: false,
    error: null,
    success: false,
    filters: {},
    chartData: {
      options: {},
      series: []
    },
  },
  animalsStatusChart: {
    requesting: false,
    error: null,
    success: false,
    filters: {},
    chartData: {
      options: {},
      series: []
    },
  },
  widgetsData: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
  topFarmers: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
  farmLocations: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  },
  topCarabaoFarmers: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
  topCattleFarmers: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
  topGoatFarmers: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
  topSheepFarmers: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
  topSwineFarmers: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
  topChickenFarmers: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
  topDuckFarmers: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    getRegisteredUsersChart: (state, action) => {		
      state.registeredUsersChart.requesting = true;
      state.registeredUsersChart.error = null;
      state.registeredUsersChart.success = false;
      state.registeredUsersChart.filters = action.payload;
    },
    getRegisteredUsersChartSuccess: (state, action) => {
      const { categories, series } = action.payload;
      state.registeredUsersChart.requesting = false;
      state.registeredUsersChart.success = true;
      state.registeredUsersChart.chartData.options = createMixedChartOptions(categories, series);
      state.registeredUsersChart.chartData.series = series;
    },
    getRegisteredUsersChartFail: (state, action) => {   
      state.registeredUsersChart.requesting = false;
      state.registeredUsersChart.error = action.payload;
      state.registeredUsersChart.success = false;
    },

    getRegisteredAnimalsChart: (state, action) => {		
      state.registeredAnimalsChart.requesting = true;
      state.registeredAnimalsChart.error = null;
      state.registeredAnimalsChart.success = false;
      state.registeredAnimalsChart.filters = action.payload;
    },
    getRegisteredAnimalsChartSuccess: (state, action) => {
      const { categories, series } = action.payload;
      state.registeredAnimalsChart.requesting = false;
      state.registeredAnimalsChart.success = true;
      state.registeredAnimalsChart.chartData.options = createLineChartOptions(categories, 'Registered Animals');
      state.registeredAnimalsChart.chartData.series = series;
    },
    getRegisteredAnimalsChartFail: (state, action) => {   
      state.registeredAnimalsChart.requesting = false;
      state.registeredAnimalsChart.error = action.payload;
      state.registeredAnimalsChart.success = false;
    },

    getAnimalsStatusChart: (state, action) => {		
      state.animalsStatusChart.requesting = true;
      state.animalsStatusChart.error = null;
      state.animalsStatusChart.success = false;
      state.animalsStatusChart.filters = action.payload;
    },
    getAnimalsStatusChartSuccess: (state, action) => {
      const { categories, series } = action.payload;
      state.animalsStatusChart.requesting = false;
      state.animalsStatusChart.success = true;
      state.animalsStatusChart.chartData.options = createLineChartOptions(categories, 'Animals Conditions');
      state.animalsStatusChart.chartData.series = series;
    },
    getAnimalsStatusChartFail: (state, action) => {   
      state.animalsStatusChart.requesting = false;
      state.animalsStatusChart.error = action.payload;
      state.animalsStatusChart.success = false;
    },  
    
    getWidgetData: (state, action) => {		      
      state.widgetsData.requesting = true;
      state.widgetsData.error = null;
      state.widgetsData.success = false;
      state.widgetsData.filters = action.payload;
    },
    getWidgetDataSuccess: (state, action) => {
      state.widgetsData.requesting = false;
      state.widgetsData.data = action.payload;
      state.widgetsData.success = true; 
    },
    getWidgetDataFail: (state, action) => {        
      state.widgetsData.requesting = false;
      state.widgetsData.error = action.payload;
    },

    getTopFarmers: (state, action) => {		      
      state.topFarmers.requesting = true;
      state.topFarmers.error = null;
      state.topFarmers.success = false;
      state.topFarmers.filters = action.payload;
    },
    getTopFarmersSuccess: (state, action) => {
      state.topFarmers.requesting = false;
      state.topFarmers.items = action.payload;
      state.topFarmers.success = true; 
    },
    getTopFarmersFail: (state, action) => {        
      state.topFarmers.requesting = false;
      state.topFarmers.error = action.payload;
    },

    getTopCarabaoFarmers: (state, action) => {		      
      state.topCarabaoFarmers.requesting = true;
      state.topCarabaoFarmers.error = null;
      state.topCarabaoFarmers.success = false;
      state.topCarabaoFarmers.filters = action.payload;
    },
    getTopCarabaoFarmersSuccess: (state, action) => {
      state.topCarabaoFarmers.requesting = false;
      state.topCarabaoFarmers.items = action.payload;
      state.topCarabaoFarmers.success = true; 
    },
    getTopCarabaoFarmersFail: (state, action) => {        
      state.topCarabaoFarmers.requesting = false;
      state.topCarabaoFarmers.error = action.payload;
    },

    getTopCattleFarmers: (state, action) => {		      
      state.topCattleFarmers.requesting = true;
      state.topCattleFarmers.error = null;
      state.topCattleFarmers.success = false;
      state.topCattleFarmers.filters = action.payload;
    },
    getTopCattleFarmersSuccess: (state, action) => {
      state.topCattleFarmers.requesting = false;
      state.topCattleFarmers.items = action.payload;
      state.topCattleFarmers.success = true; 
    },
    getTopCattleFarmersFail: (state, action) => {        
      state.topCattleFarmers.requesting = false;
      state.topCattleFarmers.error = action.payload;
    },

    getTopGoatFarmers: (state, action) => {		      
      state.topGoatFarmers.requesting = true;
      state.topGoatFarmers.error = null;
      state.topGoatFarmers.success = false;
      state.topGoatFarmers.filters = action.payload;
    },
    getTopGoatFarmersSuccess: (state, action) => {
      state.topGoatFarmers.requesting = false;
      state.topGoatFarmers.items = action.payload;
      state.topGoatFarmers.success = true; 
    },
    getTopGoatFarmersFail: (state, action) => {        
      state.topGoatFarmers.requesting = false;
      state.topGoatFarmers.error = action.payload;
    },

    getTopSheepFarmers: (state, action) => {		      
      state.topSheepFarmers.requesting = true;
      state.topSheepFarmers.error = null;
      state.topSheepFarmers.success = false;
      state.topSheepFarmers.filters = action.payload;
    },
    getTopSheepFarmersSuccess: (state, action) => {
      state.topSheepFarmers.requesting = false;
      state.topSheepFarmers.items = action.payload;
      state.topSheepFarmers.success = true; 
    },
    getTopSheepFarmersFail: (state, action) => {        
      state.topSheepFarmers.requesting = false;
      state.topSheepFarmers.error = action.payload;
    },

    getTopSwineFarmers: (state, action) => {		      
      state.topSwineFarmers.requesting = true;
      state.topSwineFarmers.error = null;
      state.topSwineFarmers.success = false;
      state.topSwineFarmers.filters = action.payload;
    },
    getTopSwineFarmersSuccess: (state, action) => {
      state.topSwineFarmers.requesting = false;
      state.topSwineFarmers.items = action.payload;
      state.topSwineFarmers.success = true; 
    },
    getTopSwineFarmersFail: (state, action) => {        
      state.topSwineFarmers.requesting = false;
      state.topSwineFarmers.error = action.payload;
    },

    getTopChickenFarmers: (state, action) => {		      
      state.topChickenFarmers.requesting = true;
      state.topChickenFarmers.error = null;
      state.topChickenFarmers.success = false;
      state.topChickenFarmers.filters = action.payload;
    },
    getTopChickenFarmersSuccess: (state, action) => {
      state.topChickenFarmers.requesting = false;
      state.topChickenFarmers.items = action.payload;
      state.topChickenFarmers.success = true; 
    },
    getTopChickenFarmersFail: (state, action) => {        
      state.topChickenFarmers.requesting = false;
      state.topChickenFarmers.error = action.payload;
    },

    getTopDuckFarmers: (state, action) => {		      
      state.topDuckFarmers.requesting = true;
      state.topDuckFarmers.error = null;
      state.topDuckFarmers.success = false;
      state.topDuckFarmers.filters = action.payload;
    },
    getTopDuckFarmersSuccess: (state, action) => {
      state.topDuckFarmers.requesting = false;
      state.topDuckFarmers.items = action.payload;
      state.topDuckFarmers.success = true; 
    },
    getTopDuckFarmersFail: (state, action) => {        
      state.topDuckFarmers.requesting = false;
      state.topDuckFarmers.error = action.payload;
    },
    
    getFarmLocations: (state, action) => {		      
      state.farmLocations.requesting = true;
      state.farmLocations.error = null;
      state.farmLocations.success = false;
      state.farmLocations.filters = action.payload;
    },
    getFarmLocationsSuccess: (state, action) => {
      state.farmLocations.requesting = false;
      state.farmLocations.items = action.payload;
      state.farmLocations.success = true; 
    },
    getFarmLocationsFail: (state, action) => {        
      state.farmLocations.requesting = false;
      state.farmLocations.error = action.payload;
    },
  },
})

export const { 
  setDashboardFilters, resetDashboardFilters,
  getRegisteredUsersChart, getRegisteredUsersChartSuccess, getRegisteredUsersChartFail,
  getRegisteredAnimalsChart, getRegisteredAnimalsChartSuccess, getRegisteredAnimalsChartFail,
  getAnimalsStatusChart, getAnimalsStatusChartSuccess, getAnimalsStatusChartFail,
  getWidgetData, getWidgetDataSuccess, getWidgetDataFail,
  getTopFarmers, getTopFarmersSuccess, getTopFarmersFail,
  getFarmLocations, getFarmLocationsSuccess, getFarmLocationsFail,
  getTopCarabaoFarmers, getTopCarabaoFarmersSuccess, getTopCarabaoFarmersFail,
  getTopCattleFarmers, getTopCattleFarmersSuccess, getTopCattleFarmersFail,
  getTopGoatFarmers, getTopGoatFarmersSuccess, getTopGoatFarmersFail,
  getTopSheepFarmers, getTopSheepFarmersSuccess, getTopSheepFarmersFail,
  getTopSwineFarmers, getTopSwineFarmersSuccess, getTopSwineFarmersFail,
  getTopChickenFarmers, getTopChickenFarmersSuccess, getTopChickenFarmersFail,
  getTopDuckFarmers, getTopDuckFarmersSuccess, getTopDuckFarmersFail
} = dashboardSlice.actions

export default dashboardSlice.reducer